module.exports = __webpack_public_path__ + "img/8.376be1da.webp";